import styled, { css } from 'styled-components';
import { Card } from '../main/CommonStyles';

const getStatusStyles = (status, theme) => {
    switch (status) {
        case 'CONFIRMED':
            return css`
                background-color: ${theme.colors.secondaryLight + '30'};
                border-left-color: ${theme.colors.secondary};
            `;
        case 'PENDING_CONFIRMATION':
            return css`
                background-color: #fffbe6;
                border-left-color: #f59e0b;
            `;
        case 'CANCELLED_BY_PATIENT':
        case 'CANCELLED_BY_PSYCHOLOGIST':
            return css`
                background-color: ${theme.colors.dangerBg};
                border-left-color: ${theme.colors.danger};
                opacity: 0.8;
            `;
        default:
            return css`
                background-color: ${theme.colors.neutralLight};
                border-left-color: ${theme.colors.textDisabled};
            `;
    }
};

export const AppointmentList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1.25rem;
`;

export const AppointmentCard = styled(Card)`
    display: flex;
    align-items: center;
    gap: 1.5rem;
    padding: 1.25rem;
    border-left: 5px solid;
    ${({ status, theme }) => getStatusStyles(status, theme)};
`;

export const AppointmentDetails = styled.div`
    flex-grow: 1;
    p {
        margin: 0;
        line-height: 1.4;
    }
`;

export const StatusBadge = styled.span`
    font-size: 0.8rem;
    font-weight: 700;
    padding: 0.3rem 0.8rem;
    border-radius: 50px;
    text-transform: capitalize;
    white-space: nowrap;
    color: #fff;
    background-color: ${({ status, theme }) => {
    if (status === 'CONFIRMED') return theme.colors.secondaryDark;
    if (status === 'PENDING_CONFIRMATION') return '#f59e0b';
    return theme.colors.textDisabled;
}};
`;